import axios from 'axios';
import Vue from 'vue'

export default {

    getOrders (page, pageSize, showDrafts,status,customerId, reference) {
        return axios.get('/api/orders/list', { params: { page: page, pageSize: pageSize, showDrafts: showDrafts , status:status,customerId:customerId, reference:reference} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getOrder (orderId, showTransfer) {
        return axios.get('/api/orders/order', { params: { orderId: orderId, showTransfer:showTransfer } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getCashOnlyConsolidatedOrder (orderId, showTransfer) {
        return axios.get('/api/orders/order', { params: { orderId: orderId, showTransfer:showTransfer, onlyCashPayment:true } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    getOrdersByCustomer (page, pageSize,supplierId, onlyDrafts,promotionId,status) {
        return axios.get('/api/orders/customer/list', { params: { page: page, pageSize: pageSize,supplierId:supplierId, showDrafts: onlyDrafts, promotionId:promotionId, status : status} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getOrdersByCustomerAndPromtion (page, pageSize,supplierId, onlyDrafts,promotionId,status) {
        return axios.get('/api/orders/customer/promotion/list', { params: { page: page, pageSize: pageSize,supplierId:supplierId, showDrafts: onlyDrafts, promotionId:promotionId, status : status} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    addLineToOrder (orderId, itemId, quantity, supplierId, promotionId , isChecked) {
        var orderLine = {orderId: orderId, itemId: itemId, quantity: quantity, supplierId: supplierId, promotionId: promotionId,isCashPaymentDiscountChecked:isChecked }
        
        return axios.post('/api/orders/line/add', orderLine)
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    editLineToOrder (orderId, itemId, quantity, supplierId, promotionId, isChecked) {
        var orderLine = {orderId: orderId, itemId: itemId, quantity: quantity, supplierId: supplierId, promotionId:promotionId,isCashPaymentDiscountChecked:isChecked}
        
        return axios.post('/api/orders/line/edit', orderLine)
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    submitOrder (orderId, message, priority, deliveryAddress, isChecked) {    
        var request = {orderId: orderId, message: message, priority: priority, deliveryAddress: deliveryAddress,isCashPaymentDiscountChecked:isChecked}    
        return axios.post('/api/orders/submit', request)
        .then(response => {
            if (response && response.data) {

                if(response.data.warningMessage){
                      Vue.prototype.$snotify.html(
                        `<div class="snotify-custom-toast p-3 bg-success rounded" >
                            <div class="fw-bold text-white">Commande validée avec succès</div>
                            <div class="mt-3 text-white font-weight-bold font-size-14  ">${response.data.warningMessage ?? ''}</div>
                        </div>`
                );
                }else{
                    Vue.prototype.$snotify.success("Commande validée avec succès")
                }

               
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error); return false;})
    },

    removeOrderLine (orderId, itemId, supplierId,isChecked) {
        var orderLine = {orderId: orderId, itemId: itemId, supplierId: supplierId,isCashPaymentDiscountChecked:isChecked}
        return axios.post('/api/orders/remove',orderLine )
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getOrderLines(orderId) {
        return axios.get('/api/orders/order',{params: {orderId: orderId}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    removeDraft (draft) {
        return axios.post('/api/orders/draft/remove', draft)
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    resetConfirmedQuantity (itemRef, promotionId, showTransfer) {
        return axios.get('/api/orders/reset/confirmQuantity', { params: { itemRef:itemRef, promotionId: promotionId, showTransfer:showTransfer } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveConfirmedQuantity (orderLineId, confirmedQuantity) {
        return axios.post('/api/orders/confirmQuantity', { orderLineId: orderLineId, confirmedQuantity: confirmedQuantity } )
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    confirmOrder (orderId, deliveryMode, parcelsNumber, invoiceAmountTaxIncl) {
        return axios.post('/api/orders/confirmOrder', { orderId: orderId, deliveryMode: deliveryMode, parcelsNumber: parcelsNumber, invoiceAmountTaxIncl:invoiceAmountTaxIncl } )
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    deliverOrder (orderId, deliveryMode, parcelsNumber, invoiceAmountTaxIncl) {
        return axios.post('/api/orders/deliverOrder', { orderId: orderId, deliveryMode: deliveryMode, parcelsNumber: parcelsNumber, invoiceAmountTaxIncl: invoiceAmountTaxIncl } )
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getCashPaymentDiscount(supplierId,promotionId){
        return axios.get('/api/orders/cashPaymentDiscount',{params: {supplierId: supplierId, promotionId:promotionId}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    cancelOrder (orderId) {
        return axios.post('/api/orders/cancelOrder', { orderId: orderId } )
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    togglePaymentMode (orderId) {
        return axios.post('/api/orders/toggle-payment', { orderId: orderId } )
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    editPaymentMethod(order,paymentMethod) {
        return axios.post('/api/orders/editPaymentMethod', {orderId:order.id , paymentMethod:paymentMethod})
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    editCashPaymentDiscount(order,isChecked) {
        return axios.post('/api/orders/editCashPaymentDiscount', {orderId:order.id , isChecked:isChecked})
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getOrdersCount(){
        return axios.get('/api/orders/count/')
        .then(response => {
            if (response && response.data)  return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    getTotalTurnover(month,year,isMonthly,isYearly){
        return axios.get('/api/orders/turnover', { params: { month: month, year:year, isMonthly:isMonthly,isYearly:isYearly } } )
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getTopTenItems(){
        return axios.get('/api/orders/toptenItems')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getTotalSales(start,end,isCurrentMonth){
        return axios.get('/api/orders/totalSales' ,{params: {start:start,end:end,isCurrentMonth:isCurrentMonth} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getTotalSalesJson(start,end,isCurrentMonth){
        return axios.get('/api/orders/totalSalesJson' ,{params: {start:start,end:end,isCurrentMonth:isCurrentMonth} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getVolumeOfPurchasesBySupplier(year){
        return axios.get('/api/orders/volumeOfPurchasesBySupplier',{params: {year: year} }) 
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getTotalSalesPerCustomerAndSupplier(page,pageSize,start,end,customerId,supplierId,isCurrentMonth,isListPerCustomer,isListPerSupplier){
        return axios.get('/api/orders/totalSalesPerCustomerAndSupplier',{params: {page: page, pageSize: pageSize, start:start,end:end,customerId:customerId,supplierId:supplierId,isCurrentMonth:isCurrentMonth,isListPerCustomer:isListPerCustomer,isListPerSupplier:isListPerSupplier} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getMonthlyDiscount(){
        return axios.get('/api/orders/monthlyDiscount')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    getYearlyDiscount(){
        return axios.get('/api/orders/yearlyDiscount')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getReportingDiscountGraph(start,end){
            return axios.get('/api/orders/reportingDiscountGraph', { params: {start:start,end:end } })
            .then(response => {
                if (response && response.data) return response.data
            })
            .catch(error => {Vue.prototype.$snotify.error(error);})
        },

    getCustomerQuickReporting(){
        return axios.get('/api/orders/customer/quick-reporting')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getCustomerDailyInfo(){
        return axios.get('/api/orders/customer/daily-info')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
        

    getAllOrders (page, pageSize,supplierId,customerId,status,showDrafts,reference) {
        return axios.get('/api/orders/all', { params: { page: page, pageSize: pageSize, supplierId: supplierId,customerId:customerId , status:status, showDrafts:showDrafts, reference:reference} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    checkCondition(orderId, message, priority, deliveryAddress, isChecked){

        var request = {orderId: orderId, message: message, priority: priority, deliveryAddress: deliveryAddress,isCashPaymentDiscountChecked:isChecked} 

        return axios.post('/api/orders/check/condition', request)

        .then(response => {

            if (response && response.data) {

                return response.data;

            }

        })

        .catch(error => {Vue.prototype.$snotify.error(error); return false;})

    },

    downloadShipoxAwb(orderId){
        return axios.get('/api/orders/shipox/awb/' + orderId )
            .then(response => {
                if (response && response.data) return response.data
            })
            .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    exportPurchaseOrder(promotion) {
      const now = new Date();
    
     return axios({
        url: '/api/orders/export/purchaseOrder/' + promotion.id,
        method: 'GET',
        responseType: 'blob',
        }).then((response) => {

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        const formattedTimestamp = `${now.getFullYear()}-${String(  now.getMonth() + 1   ).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}-${String(      now.getHours()  ).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String( now.getSeconds()).padStart(2, '0')}`;
        link.setAttribute('download', `${formattedTimestamp}_${promotion.title}.zip`);
        document.body.appendChild(link);
        link.click();
        }).catch(() => {Vue.prototype.$snotify.error("Echec de Téléchargement de commandes. Veuillez vérifier si des commandes existent pour cette offre !");});
    },
    

    downloadFParcelAwb(orderId){
         
        axios({
            url:'/api/orders/shipox/awb/' + orderId,
            method: 'GET',
            responseType: 'blob', // important
            }).then((response) => {

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Bordereau-Livraison.pdf');
            document.body.appendChild(link);
            link.click();
            });
    },

    transferPreOrder (promotionId, supplierId) {
        return axios.post('/api/orders/transferPreOrder/' + (promotionId * -1) + '/' + supplierId)
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getOrdersStatus(start,end,customerId,supplierId,isCurrentMonth){
        return axios.get('/api/orders/ordersStatus',{params: {start:start,end:end,customerId:customerId,supplierId:supplierId,isCurrentMonth:isCurrentMonth} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getConsolidatedPreOrderTotalQty(orderId){
        return axios.get('/api/orders/consolidatedPreOrderTotalQty',{params: {orderId:orderId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    exportEXCEL(orderId){
        axios({
            url:'/api/orders/export/excel/'+orderId,
            method: 'GET',
            responseType: 'blob', // important
          }).then((response) => {
            const blob = new Blob(
                [response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' })
                const aEle = document.createElement('a');     // Create a label
                const href = window.URL.createObjectURL(blob);       // Create downloaded link
                aEle.href = href;
                aEle.download = response.headers["filename"];  // File name after download
                document.body.appendChild(aEle);
                aEle.click();     // Click to download
                document.body.removeChild(aEle); // Download complete remove element
                window.URL.revokeObjectURL(href) // Release blob object
          });
    },

    convertOrder (orderId) {
        return axios.get('/api/orders/to-invoice', { params: { orderId: orderId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    getPreviousYearReporting () {
        return axios.get('/api/orders/previousYearReporting')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    postPayment(forfaits, method){

        const payment = {
            items:forfaits,
            paymentMethod:method
        }
        return axios.post('/api/orders/payment', payment)
        .then(response => {
            if (response && response.data){
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})

    }

}

